requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xFormSF', {
      show: false,
      loading: false,
      // Drive snippets/hubspot-form-stage.liquid in form-popup-host: `ready` hides the skeleton,
      // `failed` shows the email fallback, `formId` picks the reserved height.
      ready: true,
      failed: false,
      formId: '',
      _activeWrapper: null,
      cached: [],
      selected: false,
      _formConfigCache: {},
      _formConfigNodes: {},
      _mountedForms: {},
      _overrideForm: null,

      load(url, element, id, formName) {
        if (!this.cached.includes(id)) {
          this.cached.push(id);
        }
      },

      _getFormContainer() {
        return document.getElementById('form-popup-content-shared');
      },

      _refreshFormConfigNodes() {
        var configs = document.querySelectorAll('[data-form-popup-name]');
        this._formConfigNodes = {};

        for (var i = 0; i < configs.length; i++) {
          var name = configs[i].getAttribute('data-form-popup-name');
          if (!name) continue;

          this._formConfigNodes[name] = configs[i];
        }
      },

      _getFormConfig(name) {
        var node = this._formConfigNodes[name];

        if (!node || !node.isConnected) {
          this._refreshFormConfigNodes();
          node = this._formConfigNodes[name];
        }

        if (!node) return null;

        var source = node.textContent;
        var cachedConfig = this._formConfigCache[name];

        if (cachedConfig && cachedConfig.source === source) {
          return cachedConfig.data;
        }

        try {
          var data = JSON.parse(source);
          this._formConfigCache[name] = {
            source: source,
            data: data
          };
          return data;
        } catch (error) {
          console.warn('Could not parse form config for', name, error);
          return null;
        }
      },

      // Copies the form section's side image, if any, into form-popup-host's slot. An empty slot
      // leaves the dialog at its plain width (the CSS keys off :empty).
      _showImage(name) {
        var slot = document.getElementById('form-popup-image');
        if (!slot) return;

        var source = document.querySelector('template[data-form-popup-image="' + name + '"]');
        slot.replaceChildren();
        if (source) slot.appendChild(source.content.cloneNode(true));
      },

      _getFormSignature(config) {
        if (!config) return '';

        return [
          config.region || 'na1',
          config.formId || '',
          config.portalId || ''
        ].join(':');
      },

      // Appends the wrapper to `container` before mounting, so the .hs-form-html is already
      // in the document when HubSpot's observer picks it up and when on-ready resolves it.
      // Returns null rather than an empty wrapper when the runtime is missing, so the
      // caller does not cache a shell that can never fill itself.
      _createHubspotWrapper(container, config, fields) {
        if (!window.LeibishHubSpot) return null;

        var wrapper = document.createElement('div');
        wrapper.hidden = true;
        wrapper.setAttribute('data-form-signature', this._getFormSignature(config));
        container.appendChild(wrapper);

        // region and fields are normalized by LeibishHubSpot.mount(); no defaults here.
        var frame = window.LeibishHubSpot.mount(wrapper, {
          formId: config.formId,
          portalId: config.portalId,
          region: config.region,
          fields: fields
        });

        // The state lives on the wrapper, which outlives a single open (see _showWrapper).
        wrapper._hsStopTracking = window.Eurus.trackHsForm(frame, {
          onReady: () => this._setWrapperState(wrapper, 'ready'),
          onFail: () => this._setWrapperState(wrapper, 'failed')
        });

        return wrapper;
      },

      // Frames must be unmounted before they leave the DOM: the runtime matches on-ready
      // events to queued mounts, and a discarded mount that stayed queued would hand its
      // `fields` to the next frame of the same form.
      _removeWrapper(wrapper) {
        if (!wrapper) return;
        if (wrapper._hsStopTracking) wrapper._hsStopTracking();
        if (window.LeibishHubSpot) window.LeibishHubSpot.unmount(wrapper);
        if (wrapper.parentNode) wrapper.parentNode.removeChild(wrapper);
      },

      _hideMountedForms() {
        for (var name in this._mountedForms) {
          if (!Object.prototype.hasOwnProperty.call(this._mountedForms, name)) continue;

          this._mountedForms[name].hidden = true;
        }
      },

      _clearOverrideForm() {
        this._removeWrapper(this._overrideForm);
        this._overrideForm = null;
      },

      // Wrappers are kept across opens, so a form that already loaded reopens without the
      // skeleton, and one that already failed reopens straight to the email fallback (a late
      // on-ready still clears it).
      _showWrapper(wrapper, formId) {
        wrapper.hidden = false;
        this._activeWrapper = wrapper;
        this.formId = formId || '';
        this._syncStage(wrapper);
      },

      _setWrapperState(wrapper, state) {
        wrapper.setAttribute('data-hs-state', state);
        if (wrapper === this._activeWrapper) this._syncStage(wrapper);
      },

      _syncStage(wrapper) {
        var state = wrapper.getAttribute('data-hs-state');
        this.ready = state === 'ready' || state === 'failed';
        this.failed = state === 'failed';
      },

      _ensureMountedForm(name, config) {
        var container = this._getFormContainer();

        if (!container || !config || !config.formId || !config.portalId) {
          return null;
        }

        var mountedForm = this._mountedForms[name];
        var formSignature = this._getFormSignature(config);

        if (mountedForm) {
          var mountedInRightContainer = mountedForm.parentNode === container;
          var mountedSignature = mountedForm.getAttribute('data-form-signature');

          if (!mountedForm.isConnected || !mountedInRightContainer || mountedSignature !== formSignature) {
            this._removeWrapper(mountedForm);
            delete this._mountedForms[name];
            mountedForm = null;
          }
        }

        if (!mountedForm) {
          mountedForm = this._createHubspotWrapper(container, config);
          if (!mountedForm) return null;
          this._mountedForms[name] = mountedForm;
        }

        return mountedForm;
      },

      _mountOverrideForm(config, fields) {
        var container = this._getFormContainer();

        if (!container || !config || !config.formId || !config.portalId) {
          return false;
        }

        this._clearOverrideForm();
        this._hideMountedForms();

        var overrideForm = this._createHubspotWrapper(container, config, fields);
        if (!overrideForm) return false;

        this._overrideForm = overrideForm;
        this._showWrapper(overrideForm, config.formId);

        return true;
      },

      open(name) {
        var config = this._getFormConfig(name);
        var mountedForm = this._ensureMountedForm(name, config);

        if (!mountedForm) {
          return;
        }

        this._clearOverrideForm();
        this._hideMountedForms();
        this._showWrapper(mountedForm, config.formId);
        this._showImage(name);
        this.show = name;
        Alpine.store('xPopup').open = true;
      },

      // Product context is written straight into the form's hidden fields via the documented
      // V4 setFieldValue() API (applied in snippets/hubspot-forms.liquid on ready), so the
      // page URL is never rewritten.
      openWithHubspot(name, formId, sku, title, productUrl) {
        var fields = {};
        var content = [];

        if (title && sku) {
          fields.subject = title + ' (SKU: ' + sku + ')';
        } else if (title) {
          fields.subject = title;
        } else if (sku) {
          fields.subject = 'SKU: ' + sku;
        }
        if (sku) {
          fields.sku = sku;
        }
        if (title) {
          content.push('Product: ' + title);
          fields.product_name = title;
        }
        if (sku) content.push('SKU: ' + sku);
        if (productUrl) {
          content.push('URL: ' + productUrl);
          fields.product_url = productUrl;
        }
        if (content.length) fields.content = content.join('\n');

        if (!this._mountOverrideForm({
          formId: formId,
          portalId: window.LeibishHubSpot && window.LeibishHubSpot.portalId
        }, fields)) {
          this.open(name);
          return;
        }

        this._showImage(name);
        this.show = name;
        Alpine.store('xPopup').open = true;
      },

      close() {
        setTimeout(() => {
          this._hideMountedForms();
          this._clearOverrideForm();
          this._activeWrapper = null;
          this.show = false;
          if (!Alpine.store('xQuickView') || Alpine.store('xQuickView').show == false) {
            Alpine.store('xPopup').open = false;
          }
        }, 0);
      },

      removeFocusQuickView() {
        if (!this.selected) {
          const elementActive = document.getElementById("button_quickview");
          Alpine.store('xFocusElement').removeTrapFocus(elementActive);
        }
      },
    });
  });
});
